import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Tribute from './components/Tribute';
import Contact from './components/Contact';
import './styles/App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Projects />
        <Skills />
        <Tribute />
        <Contact />
      </div>
    </HelmetProvider>
  );
}

export default App;
